// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.todolist.focused {
  background-color: #e6f4f7;
  border-color: #3faac3;
}

.ql-editor, .ql-editor.ql-blank::before {
  color: #a3a3a3;
  font-family: "Poppins";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}

.ql-editor {
  color: black;
}

.ql-container.ql-snow {
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  border: 1px solid var(--true-gray-truegray-200, #e5e5e5);
}

.ql-toolbar.ql-snow {
  font-family: "Poppins";
  background-color: rgb(248, 248, 248);
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  border: 1px solid var(--true-gray-truegray-200, #e5e5e5);
}
`, "",{"version":3,"sources":["webpack://./src/components/toDo/style.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,wDAAwD;AAC1D;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,2BAA2B;EAC3B,4BAA4B;EAC5B,wDAAwD;AAC1D","sourcesContent":[".todolist.focused {\n  background-color: #e6f4f7;\n  border-color: #3faac3;\n}\n\n.ql-editor, .ql-editor.ql-blank::before {\n  color: #a3a3a3;\n  font-family: \"Poppins\";\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n}\n\n.ql-editor {\n  color: black;\n}\n\n.ql-container.ql-snow {\n  border-bottom-left-radius: 8px;\n  border-bottom-right-radius: 8px;\n  border: 1px solid var(--true-gray-truegray-200, #e5e5e5);\n}\n\n.ql-toolbar.ql-snow {\n  font-family: \"Poppins\";\n  background-color: rgb(248, 248, 248);\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n  border: 1px solid var(--true-gray-truegray-200, #e5e5e5);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
